import authenticationService from '@/services/authentication'

const initialState = () => ({
  cpf: '',
  email: '',
  identifier: '',
  loginType: 'cpf', // 'cpf' ou 'email'
  nome: '',
  senha: '',
  termos: false,
  agendamentoExpress: true
})

const state = initialState()

const mutations = {
  RESET: state => {
    Object.assign(state, initialState())
  },
  SET_CPF: (state, payload) => {
    state.cpf = payload
  },
  SET_IDENTIFIER: (state, identifier) => {
    state.identifier = identifier
  },
  SET_LOGIN_TYPE: (state, loginType) => {
    state.loginType = loginType
  },
  SET_SENHA: (state, senha) => {
    state.senha = senha
  },
  SET_TERMOS: (state, termos) => {
    state.termos = termos
  },
  SET_NOME: (state, nome) => {
    state.nome = nome
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_AGENDAMENTO_EXPRESS: (state, agendamentoExpress) => {
    state.agendamentoExpress = agendamentoExpress
  }
}

const actions = {
  searchCpf: async ({ state, commit }) => {
    const { cpf } = state

    const { status, novoAcesso, nome, email, agendamentoExpress } = await authenticationService.searchCpf(cpf)

    commit('SET_NOME', nome)
    commit('SET_EMAIL', email)
    commit('SET_AGENDAMENTO_EXPRESS', agendamentoExpress)

    return { status, novoAcesso }
  },
  searchIdentifier: async ({ state, commit }) => {
    const { identifier } = state

    const { status, novoAcesso, nome, email, agendamentoExpress } = await authenticationService.searchUser(identifier)

    commit('SET_NOME', nome)
    commit('SET_EMAIL', email)
    commit('SET_AGENDAMENTO_EXPRESS', agendamentoExpress)

    return { status, novoAcesso }
  },
  login: async ({ state, commit }, senha) => {
    const { cpf, identifier, loginType, agendamentoExpress } = state

    let data
    if (loginType === 'email') {
      const response = await authenticationService.loginWithEmail(identifier, senha)
      data = response.data
    } else {
      const response = await authenticationService.login(cpf, senha)
      data = response.data
    }

    if (data) {
      data.agendamentoExpress = agendamentoExpress
    }
    commit('RESET')

    return data
  },
  register: async ({ state, commit }, { nome }) => {
    const { cpf, senha } = state

    const { data } = await authenticationService.register({
      cpf,
      nome,
      senha
    })

    commit('RESET')

    return data
  }
}

export default { namespaced: true, state, mutations, actions }
